import React from 'react';
import { Alert, Text } from '@gjensidige/builders-components';
import { Coverage, HeaderSmallScreen } from '../../../interfaces/Types';
import { CoverageList } from '../../CoverageList/CoverageList';
interface Props {
  header?: HeaderSmallScreen;
  includedCoverages: Coverage[];
  excludedCoverages: Coverage[];
  disabledMessage?: string;
  isEnabled: boolean;
}

export type ComponentProps = Props;

export const InsuranceTileContentSmallScreen: React.FC<Props> = ({
  header,
  includedCoverages,
  excludedCoverages,
  isEnabled,
  disabledMessage
}: Props) => {

  const showDisabledMessage = !isEnabled && !!disabledMessage;

  return (
    <div className={`small-screen-coverage-wrapper ${showDisabledMessage ? 'pb-3' : ''}`}>
      {header?.priceLabel && header?.monthlyPrice && isEnabled ? (
        <>
          {includedCoverages?.length > 0 && (
            <CoverageList coverages={includedCoverages} includedCoverage />
          )}
          {excludedCoverages?.length > 0 && (
            <CoverageList coverages={excludedCoverages} />
          )}
        </>
      ) : showDisabledMessage ? (
        <Alert
          severity="informative"
          variant="outlined"
          className="mx-2"
        >
          <Text size="body" dangerouslySetInnerHTML={{ __html: disabledMessage }}></Text>
        </Alert>
      ) : (
        <></>
      )}
    </div>
  );
};
